export default {
      id: "piezometer-usage",
      viewBox: "0 0 4.408 16.192",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#piezometer",
      toString: function () {
        return this.url;
      }
    }